module.exports = {
  OK: '确定',
  CANCEL: '取消',
  login_TITLE: '登录',
  login_USERNAME: '用户名:',
  login_PASSWORD: '密码:',
  login_LANGUAGE: '语言:',
  login_SAVEPASSWORD: '保存密码',
  login_failure: '用户名或密码错误。',
  main_title: '货代管理',
  main_user: '用户:',
  main_office: '所属公司:',
  main_LOGOUT_TOOLTIP: '退出登录',
  main_CHANGE_PASSWORD_TOOLTIP: '更改密码.',
  main_REFRESH_TOOLTIP: '更新缓存数据.',
  main_HELP_TOOLTIP: '帮助页.',
  main_LOADING_MODULE_STATUS: '加载中 {0} ...',
  main_INITIALIZING_STATUS: '加载中 ...',
  main_REFRESHING_STATUS: '更新缓存数据中 ...',
  password_title: '更改密码',
  password_oldPassword: '原密码:',
  password_newPassword: '新密码:',
  password_confirmTheNewPassword: '确认新密码:',
  password_confirmPassword: '重输密码:',
  password_notMatch: '密码不一致.',
  password_notCompliant: '密码长度8-20位，需包含数字、大写字母和小写字母',
  password_noChange: '新密码不能跟旧密码相同。',
  password_failed: '密码更改失败。请检查你的密码后重试。',
  PleaseEnterAOldPassword: '请输入原密码',
  PleaseEnterANewPassword: '请输入新密码',
  PleaseEnterTheConfirmationPassword: '请输入确认新密码',
  TheNewPasswordDoesNotMatchTheConfirmedNewPassword: '新密码和确认新密码不一致',
  TheNewPasswordDoesNotMatchTheOldPassword: '新密码不能和旧密码一致'
}
